<script>
import Swal from 'sweetalert2'
import { $axios } from '@/modules/http/axios'
import { XlsxWorkbook, XlsxSheet, XlsxDownload } from 'vue3-xlsx'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'TasksXlsxExport',
  components: { XlsxWorkbook, XlsxSheet, XlsxDownload },
  data () {
    return {
      sheets: [
        {
          name: 'Eksport zleceń',
          data: []
        }
      ],
      moment: moment
    }
  },
  computed: {
    ...mapGetters({
      'startDate': 'tasksXlsxExportModule/getStartDate'
    })
  },
  methods: {
    async initSheetData (startDate, endDate) {
      const tasks = (await $axios.get(`Task/Filtered/Dates?fromDate=${startDate}&toDate=${endDate}`)).data

      tasks.map(t => {
        const sheetDataRow = {}

        sheetDataRow['vrid'] = t.numer_Przejazdu
        sheetDataRow['FIRMA'] = t.nazna_Firmy
        sheetDataRow['Załadunek'] = t.stoppages[0]?.acronym
        sheetDataRow['Rozładunek'] = t.stoppages[t.stoppages.length - 1]?.acronym
        sheetDataRow['RZGZAŁ'] = t.stoppages[0]?.actualArrival ? moment(t.stoppages[0].actualArrival).format('DD.MM.YYYY HH:mm') : ''
        sheetDataRow['RZGROZ'] = t.stoppages.slice(-1)[0]?.actualArrival ? moment(t.stoppages.slice(-1)[0].actualArrival).format('DD.MM.YYYY HH:mm') : ''
        sheetDataRow['DATA ZAŁADUNKU.1'] = t.stoppages[0]?.arrival?.split('T')[0]
        sheetDataRow['GODZINA ZAŁADUNKU'] = t.stoppages[0]?.arrival?.split('T')[1]
        sheetDataRow['DATA ROZŁADUNKU.1'] = t.stoppages[t.stoppages.length - 1]?.arrival?.split('T')[0]
        sheetDataRow['GODZINA ROZŁADUNKU'] = t.stoppages[t.stoppages.length - 1]?.arrival?.split('T')[1]
        sheetDataRow['CIĄGNIK'] = t.auto?.plateNumber
        sheetDataRow['NACZEPA'] = t.semitrailer?.plateNumber
        sheetDataRow['KIEROWCY'] = t.kierowcy?.map(d => `${d.firstName} ${d.surname}`).join(' / ')
        sheetDataRow['STAWKA'] = t.stawka.toString().replace('.', ',')
        sheetDataRow['WALUTA'] = t.waluta
        sheetDataRow['SPEDYTOR'] = t.freightForwarder
        sheetDataRow['FV'] = t.fv
        sheetDataRow['APLIKACJA'] = t.application
        sheetDataRow['ZABEZPIECZENIE'] = t.security
        sheetDataRow['EXTRA COST CASE'] = t.extraCostCase
        sheetDataRow['OPIS 1'] = t.description1
        sheetDataRow['OPIS 2'] = t.description2
        sheetDataRow['OPIS 3'] = t.description3

        this.sheets[0].data.push(sheetDataRow)
      })
    },

    async getTasksByDates () {
      await Swal.fire({
        title: 'Wybierz datę początkową i końcową dla eksportowanych zleceń',
        icon: 'question',
        confirmButtonText: 'Generuj Excel',
        showCancelButton: true,
        cancelButtonText: 'Anuluj',
        html: `
          <div>Data początkowa:</div>
          <input class="form-control" id="start-date" type="date" value="${this.startDate}" required>
          <div class="mt-2">Data końcowa:</div>
          <input class="form-control" id="end-date" type="date" required>
        `,
        preConfirm: () => {
          return new Promise(resolve => {
            const startDate = document.getElementById('start-date').value
            const endDate = document.getElementById('end-date').value

            if (startDate === '' || endDate === '') {
              if (startDate !== '') {
                this.$store.commit('tasksXlsxExportModule/setStartDate', startDate)
              }

              Swal.fire('Proszę uzupełnić daty', '', 'warning').then(() => { this.getTasksByDates() })
            } else if (new Date(startDate) > new Date(endDate)) {
              this.$store.commit('tasksXlsxExportModule/setStartDate', startDate)
              Swal.fire('Data początkowa nie może być większa niż data końcowa', '', 'warning').then(() => { this.getTasksByDates() })
            } else {
              resolve({
                startDate: startDate,
                endDate: endDate
              })
            }
          }).then(result => {
            this.initSheetData(result.startDate, result.endDate)
          })
        }
      })
    }
  }
}
</script>

<template>
  <div class="text-center">
    <button class="btn btn-primary" @click="getTasksByDates">
      <i class="fa-solid fa-file-export"></i> Eksportuj zlecenia do Excel
    </button>

    <div v-if="sheets[0].data.length">
      <xlsx-workbook>
        <xlsx-sheet
          :collection="sheet.data"
          v-for="sheet in sheets"
          :key="sheet.name"
          :sheet-name="sheet.name"
        />
        <xlsx-download>
          <button class="btn btn-success mt-2">
            <i class="fa-solid fa-download"></i>
            Pobierz Excel ze zleceniami
          </button>
        </xlsx-download>
        <div class="text-center mt-2">
          <button class="btn btn-danger d-block w-100" @click="sheets[0].data = []">
            <i class="fa-solid fa-square-minus"></i> Wyczyść Excel
          </button>
        </div>
      </xlsx-workbook>
    </div>
  </div>
</template>
